import { render, staticRenderFns } from "./visit-team-case-manage.vue?vue&type=template&id=6f572098&scoped=true"
import script from "./visit-team-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-team-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f572098",
  null
  
)

export default component.exports